import  { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setHtmlContent } from "../../features/redux/statusFileSlice";
import { fetchOrderFile } from "../../features/action/fetchStatusFile";
import { img, so } from "../../util/icon";
import { ShowOrder } from "../common/ShowOrder";
import { ShowImgStatus } from "../common/ShowImgStatus";
import { getImageStatusFileFetch } from "../../features/action/fetchImage";
import { imgStudio } from "./main";
import { ella_in, ella_out } from "../../assets/ella_svg";
import { tanya_out, tanya_in } from "../../assets/tanya_svg";
import { irena_out, irena_in } from "../../assets/irena_svg";

export const Disigner = ({ i, setNumber, setLine, setWorkers }) => {
  const { imgStatus } = useSelector((state) => state.imageFile);
  const { htmlContent } = useSelector((state) => state.orderFile);
  const [isFlipped, setIsFlipped] = useState(false);
  const [showOrder, setShowOrder] = useState(false);
  const [showItems, setShowItems] = useState(false);
  const dispatch = useDispatch();
  const [selectedLine, setSelectedLine] = useState(null);
  const [selectedWorkers, setSelectedWorkers] = useState([]);

  const handleWorkersClick = (worker) => {
    const newWorkers = selectedWorkers.includes(worker)
      ? selectedWorkers.filter((w) => w !== worker)
      : [...selectedWorkers, worker];
    setSelectedWorkers(newWorkers);
    setWorkers(newWorkers.length > 0 ? newWorkers : null);
  };

  const isSelected = (worker) => selectedWorkers.includes(worker);
  const isSelectedLine = (line) => selectedLine === line;

  const handleLineClick = (line) => {
    if (selectedLine === line) {
      setSelectedLine(null);
      setLine(null);
    } else {
      setSelectedLine(line);
      setLine(line);
    }
  };

  const handleOpenText = (e) => {
        e.stopPropagation();
        setIsFlipped(!isFlipped);
      };
    
      const handleOpenOrder = (e, numOrder) => {
        e.stopPropagation();
        dispatch(setHtmlContent(null));
        dispatch(fetchOrderFile(numOrder));
        setShowOrder(true);
      };

  const handleOpenImage = (e, url) => {
    e.stopPropagation();
    dispatch(getImageStatusFileFetch(url));
    imgStatus && setShowItems(true);
  };

  return (
    <>
      <div className="flex flex-row w-[19.2%]">
        <div className="w-full content-center">
          <div
            className="relative w-full h-full cursor-pointer"
            onClick={handleOpenText}
            style={{ perspective: "1000px" }}
          >
            <div
              className="relative w-full h-full transition-transform duration-500"
              style={{
                transformStyle: "preserve-3d",
                transform: isFlipped ? "rotateX(180deg)" : "rotateX(0deg)",
              }}
            >
              {/* Передняя сторона - номер заказа */}
              <div
                className={'absolute w-[100%] h-full flex items-center justify-center bg-[#739D00]'}
                style={{ backfaceVisibility: "hidden" }}
              >
                <div className="flex flex-row justify-center items-center w-full overflow-hidden">
                  <p className="font-rubik font-medium text-[clamp(10px,1.2vw,16px)] leading-tight tracking-wide-5 text-[#ACCF49] px-0.5 whitespace-nowrap">
                    {i.order.slice(0, 6)}
                  </p>
                  <p className="font-rubik font-black text-[clamp(20px,3vw,40px)] leading-tight tracking-wide-5 text-[#FFFFFF] px-0.5 whitespace-nowrap">
                    {i.order.slice(6)}
                  </p>
                </div>
              </div>
              {/* Задняя сторона - текст клиента */}
              <div
                className={'absolute w-[100%] h-full flex bg-[#739D00] text-left items-center justify-center' }
                style={{
                  backfaceVisibility: "hidden",
                  transform: "rotateX(180deg)",
                }}
              >
                <div className="flex w-full h-full justify-evenly content-center items-center">
                  {/* ---------------------------------------Show HTML SO-------------------------------------------------- */}
                  <button
                    className="text-[2vw] min-w-[44px] min-h-[44px] p-2 flex items-center justify-center cursor-pointer"
                    onClick={(e) => handleOpenOrder(e, i.order)}
                  >
                    {so}
                  </button>
                  {/* ---------------------------------------Image-------------------------------------------------- */}
                  {i.img && (
                    <button
                      className="text-[2vw] min-w-[44px] min-h-[44px] p-2 flex items-center justify-center cursor-pointer"
                      onClick={(e) => handleOpenImage(e, i.img)}
                    >
                      {img}
                    </button>
                  )}
                  {/* ---------------------------------------Comment-------------------------------------------------- */}
                  {/* <div className="text-[2vw]  w-[11%] content-center ">
                    {i.comment && comment}
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
       
        {showOrder && (
          <ShowOrder setShowOrder={setShowOrder} htmlContent={htmlContent} />
        )}
        {showItems && (
          <ShowImgStatus
            url={imgStatus}
            setShowItems={setShowItems}
            loadingImage={imgStatus}
          />
        )}
      </div>
       <div className="flex w-[17.2%] items-center justify-center">
          <div className="p-2 rounded-full cursor-pointer" onClick={() => handleWorkersClick("ella")}>{isSelected("ella") ? ella_in : ella_out}</div>
          <div className="p-2 rounded-full cursor-pointer" onClick={() => handleWorkersClick("tanya")}>{isSelected("tanya") ? tanya_in : tanya_out}</div>
          <div className="p-2 rounded-full cursor-pointer" onClick={() => handleWorkersClick("irena")}>{isSelected("irena") ? irena_in : irena_out}</div>
          </div>
      <div className="flex w-[29%] items-center">
            <div className="flex w-[76%] items-center">
                  <button 
                    className={`ml-5 h-[38px] w-[40px] rounded-[50%] border-solid border-[1px] flex items-center justify-center ${isSelectedLine("L1") ? "border-[#739D00] text-[#739D00] " : "border-[#D9D9D9] hover:border-[#739D00] hover:text-[#739D00] text-[#D9D9D9]"}`}
                    onClick={() => handleLineClick("L1")}
                  >
                    <p className="font-rubik font-bold text-[20px] text-center align-middle">
                      L1
                    </p>
                  </button>
                  <input
                    type="text"
                    placeholder="|"
                    min="0"
                    step="1"
                    onChange={(e) => setNumber(e.target.value)}
                    className=" h-[40px] w-[80%] px-2 mx-2 border-solid border-[1px] border-[#D9D9D9] outline-none rounded-[10px]  "
                  />
            </div>
            <div className="w-[24%] flex items-center justify-center cursor-pointer">
              {i.status === "" ? (
                <div className="w-[24px] h-[24px] rounded-[50%] bg-[#739D00]"></div>
              ) : (
                imgStudio(i.studio)
              )}
            </div>
      </div>
    </>
  );
};
